import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { Button } from '@client/toolkit';

import { PortfolioPaths } from '../../../portfolio.router';
import { resetBuildingWizardState } from '../../wizard/building-wizard';

export function BuildingsAddButton() {
  const { t: tGlobal } = useTranslation('global');
  const { t: tCommon } = useTranslation('common');

  const navigate = useNavigate();

  const handleClickAddBuilding = () => {
    // Always start the wizard from step 1 — a previously abandoned flow should not resume here.
    resetBuildingWizardState();
    navigate(generatePath(PortfolioPaths.BuildingCreate));
  };

  return (
    <Button color="primary-dark" onClick={handleClickAddBuilding}>
      {tCommon('addEntity', { entity: tGlobal('entity.building').toLowerCase() })}
    </Button>
  );
}
